<ng-template #template>
  <div #contentElement>
    <div *ngIf="model.renderedTable.showAddRowOnTop" [class]="model.cssClasses.footer">
      <ng-container *ngTemplateOutlet="addRowButton"></ng-container>
    </div>
    <sv-ng-matrix-table *ngIf="model.renderedTable?.showTable" [question]="model" [table]="model.renderedTable"></sv-ng-matrix-table>
    <div *ngIf="!model.renderedTable.showTable" [class]="model.cssClasses.noRowsSection">
      <div [class]="model.cssClasses.noRowsText" [model]="model.locNoRowsText" sv-ng-string></div>
      <ng-container *ngIf="model.renderedTable.showAddRow">
        <ng-container  *ngTemplateOutlet="addRowButton"></ng-container>
      </ng-container>
    </div>
    <div *ngIf="model.renderedTable.showAddRowOnBottom" [class]="model.cssClasses.footer">
      <ng-container *ngTemplateOutlet="addRowButton"></ng-container>
    </div>
  </div>
  <ng-template #addRowButton>
    <button type="button" [class]="model.getAddRowButtonCss(true)" (click)="model.addRowUI()">
        <sv-ng-string [model]="model.locAddRowText" ></sv-ng-string>
        <span [class]="model.cssClasses.iconAdd"></span>
    </button>
  </ng-template>
</ng-template>